<template>
  <div class="dialog" v-if="visible">
    <div class="dialog-box">
      <div class="dialog-head">{{title}}</div>
      <div class="dialog-body">{{message}}</div>
      <div class="dialog-foot">
        <a href="javascript:;" class="primary" @click="dialogClick('submit')">确认</a>
        <a href="javascript:;" class="default" @click="dialogClick('cancel')">取消</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    title: String,
    message: String,
    visible: Boolean
  },
  methods: {
    dialogClick(type) {
      this.$emit("dialogEvent", { type: type });
    }
  }
};
</script>

<style lang="less" module>
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(53, 64, 82, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog-box {
    width: 350px;
    height: 200px;
    border-radius: 4px;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    box-sizing: border-box;
    position: relative;
  }

  .dialog-head {
    font-size: 18px;
    color: #354052;
  }

  .dialog-body {
    height: 80px;
    display: flex;
    align-items: center;
  }

  .dialog-foot {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 30px;
    right: 0;
    height: 30px;

    a {
      height: 30px;
      border-radius: 4px;
      border-style: solid;
      border-width: 1px;
      font-size: 14px;
      width: 100px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 10px;
    }

    a.primary {
      background: #4f9efa;
      border-color: #4f9efa;
      color: white;
    }

    a.default {
      background: white;
      border-color: #d8dfe5;
      color: #354052;
    }
  }
}
</style>

